import { Button } from 'components/common';
import { billing } from 'libs';

interface AddonPrice {
  description?: string;
  link?: string;
  name?: string;
  price?: number;
  stripe_price?: string;
  subscription_type?: string;
}

interface PurchaseAddonSubscriptionProps {
  hasFreePlatinum: boolean;
  hasPaymentMethod: boolean;
  isPastDue: boolean;
  onPlatinumGracePeriod: boolean;
  onShowModal: (addon: { price: AddonPrice }) => void;
  price: AddonPrice;
}

const PurchaseAddonSubscription = ({
  hasFreePlatinum,
  hasPaymentMethod,
  isPastDue,
  onPlatinumGracePeriod,
  onShowModal,
  price,
}: PurchaseAddonSubscriptionProps) => (
  <div className="card" data-testid={`subscriptions-purchase-addon-card-${price.subscription_type}`}>
    <div className="card-body">
      <div>
        <div className="align-items-center d-flex">
          <img
            alt={`${price.subscription_type} icon`}
            height={76}
            src={`/images/${price.subscription_type}.png`}
            width={76}
          />
          <div className="flex-column ms-3">
            <h4 className="fw-bold mb-2" data-testid={`subscriptions-purchase-addon-title-${price.subscription_type}`}>
              {price.name}
            </h4>
            <div className="fw-bold text-1_125">
              <span>{billing.price(price)}</span>
            </div>
          </div>
        </div>
        <div className="my-3">
          {isPastDue ? (
            <span>You cannot purchase an add-on while any of your subscription payments are past due.</span>
          ) : (
            <>
              {price.description}{' '}
              <a className="text-primary-dark" href={price.link} target="_blank" rel="noreferrer">
                Learn more
              </a>
            </>
          )}
        </div>
      </div>
      <Button
        disabled={!hasPaymentMethod || (!hasFreePlatinum && onPlatinumGracePeriod) || isPastDue}
        onClick={() => onShowModal({ price })}
        testId={`subscriptions-purchase-addon-button-${price.subscription_type}`}
        text="bold"
        variant="primary-dark"
      >
        Purchase {price.name}
      </Button>
      {!hasFreePlatinum && onPlatinumGracePeriod && (
        <div className="mt-3 text-0_75">You must resume your platinum subscription before purchasing add-ons.</div>
      )}
      {!hasPaymentMethod && (
        <div className="mt-3 text-0_75">You must enter payment details before purchasing add-ons.</div>
      )}
    </div>
  </div>
);

export default PurchaseAddonSubscription;
